module.exports = __webpack_public_path__ + "img/ser_icon.a416f3d6.svg";